/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { isIOS } from "react-device-detect";

export interface IHeroSectionProps {
    heroSectionId?: string;
    heroHeading1?: string;
    heroHeading2?: string;
    getStartedLabel?: string;
    getStartedLink?: string;
    heroImage?: string;
    heroBackgroundImage?: string;
}

const BACKGROUND_IMAGE = require("./img/hero-bg.png");

export const HeroSection = ({
    heroSectionId,
    heroHeading1,
    heroHeading2,
    getStartedLabel,
    getStartedLink,
    heroImage,
    heroBackgroundImage
}: IHeroSectionProps) => {
    const _renderHeading1 = () => {
        let _aos_props: any = {};
        if (!isIOS) {
            _aos_props = {
                "data-aos": "fade-up"
            };
        }
        if (heroHeading1) {
            return <h1 {..._aos_props}>{heroHeading1}</h1>;
        }
    };

    const _renderHeading2 = () => {
        let _aos_props: any = {};
        if (!isIOS) {
            _aos_props = {
                "data-aos": "fade-up",
                "data-aos-delay": "400"
            };
        }
        if (heroHeading2) {
            return <h2 {..._aos_props}>{heroHeading2}</h2>;
        }
    };

    const _renderHeroImg = () => {
        let _aos_props: any = {};
        if (!isIOS) {
            _aos_props = {
                "data-aos": "zoom-out",
                "data-aos-delay": "200"
            };
        }
        if (heroImage) {
            return (
                <div className="col-lg-6 hero-img" {..._aos_props}>
                    <img src={heroImage} className="img-fluid" alt="" />
                </div>
            );
        }
    };
    let _aos_props: any = {};
    if (!isIOS) {
        _aos_props = {
            "data-aos": "fade-up",
            "data-aos-delay": "600"
        };
    }
    return (
        <section
            id={heroSectionId}
            className="hero d-flex align-items-center"
            style={{
                background: `url(${heroBackgroundImage}) top center no-repeat`
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 d-flex flex-column justify-content-center">
                        {_renderHeading1()}
                        {_renderHeading2()}
                        <div {..._aos_props}>
                            <div className="text-center text-lg-start">
                                <a
                                    href={getStartedLink}
                                    className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center"
                                >
                                    <span>{getStartedLabel}</span>
                                    <i className="bi bi-arrow-right" />
                                </a>
                            </div>
                        </div>
                    </div>
                    {_renderHeroImg()}
                </div>
            </div>
        </section>
    );
};

HeroSection.defaultProps = {
    heroSectionId: "home",
    getStartedLink: "#about",
    getStartedLabel: "Get Started",
    heroBackgroundImage: BACKGROUND_IMAGE
};
